<rpc-icon-button *ngIf="isScrollToTopVisible" class="scroll-to-top" [title]="'SCROLL_TO_TOP.TITLES.TO_TOP'"
    iconName="arrow-up" (clicked)="onScrollToTopClicked()">
</rpc-icon-button>